import { render, staticRenderFns } from "./FixedIm.vue?vue&type=template&id=2808ab4e&scoped=true&"
import script from "./FixedIm.vue?vue&type=script&lang=js&"
export * from "./FixedIm.vue?vue&type=script&lang=js&"
import style0 from "./FixedIm.vue?vue&type=style&index=0&id=2808ab4e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2808ab4e",
  null
  
)

export default component.exports